import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';
import React from 'react';

import { useLocalisedRoutes } from 'src/app/views/hooks/useLocalisedRoutes';

import translations from './.vocab';

export const ContactUs = () => {
  const { t } = useTranslations(translations);
  const { createContactUsUrl } = useLocalisedRoutes();

  return (
    <>
      {`${t('role-requirements-contact-us')} `}
      <TextLink
        href={createContactUsUrl()}
        rel="noopener noreferrer"
        target="_blank"
        title={t('role-requirements-customer-service')}
      >
        {t('role-requirements-customer-service')}
      </TextLink>
    </>
  );
};
